module.exports = __webpack_public_path__ + "img/competencies_quality_swiper_01.25bc3ac4.jpg";